import { mutations } from "src/global-store.js";
import api from "src/services/api.js";

export default async function beforeEach(to, from, next) {
    mutations.setNavbarTitle("", "", false);
    const requiresAuthentication = to.matched.some(
        (record) => record.meta.requiresAuthentication,
    );
    if (to.path === "/") return next({ name: "Home" });

    if (!requiresAuthentication) {
        return next();
    }

    const token = localStorage.getItem("auth_token");
    if (!token) {
        api.logout(false);
        return next({ name: "Login", params: { redirect: to.path } });
    }

    const { requiredRoles } = to.meta;
    if (requiredRoles) {
        const role = localStorage.getItem("user_role");
        if (requiredRoles.includes(role)) {
            return next();
        }

        return next({
            name: "Unauthorized",
            params: { resourceName: to.path },
        });
    }
    // if the user is already authenticated, send them to the Dashboard
    if (to.path === "/login") return next({ name: "Home" });

    return next();
}
